import React from 'react'
import shanmedical from "../images/Shanmedical.png";

function Shanmedical() {
  return (
    <div>
         <div className="album py-0">
          <div className="container">
            <div className="row ">
              <div className="col-md-5 mt-3">
         <img src={shanmedical} className="img-fluid " alt="shanmedical" />

                </div>
                <div className="col-md-6 mt-3" >
                  <h1 className='shanmedical' style={{color:"#0691c7"}}><b>Shan Medical</b></h1>
                  <h1  className='abouthead' style={{color:"#960650"}}>Orthopedic Surgeon & Joint Replacement Specialist</h1>
                  <p style={{color:"#bc0101"}}>Dr. Rajkishore Sarkar is a qualified Orthopaedic Surgeon with an MBBS and MS in Orthopaedics from Kolkata National Medical College & Hospital. He is a Consultant Orthopaedic Surgeon dedicated to providing comprehensive diagnosis, treatment and management of various bone, joint, muscle and musculoskeletal conditions.</p>
                  <p style={{color:"#086db5"}}>A trusted healthcare clinic in <b>Circus Maidan, Hospital Para, Dutta Road Near by Dr. B C ROY POLICLINIC Katwa, Dist-Bardhaman, Pin: 713130, West Bengal | India  providing accessible and patient-focused medical care.</b></p>
               
                </div>
                </div>
                </div>
                </div>
    </div>
  )
}

export default Shanmedical